const ConsignmentChannel = `
  id
  description
  updatedAt
`;

export default ConsignmentChannel;
